import { useEffectSetStorageThemeFromApi } from './useEffectSetStorageThemeFromApi';
import { useEffectSetThemeFromLocalStorageWhenUnauthenticated } from './useEffectSetThemeFromLocalStorageWhenUnauthenticated';
/**
 * If the user is not logged in, and login is not in progress,
 * check for a theme in local storage.
 *
 * This is a feature of `useAppThemeConnector`, and should not
 * be used directly.
 */
export const useAppThemeLocalStorageConnector = () => {
    // Order here matters! We don't want to modify the storage
    // key until after we've evaluated the current theme.
    useEffectSetThemeFromLocalStorageWhenUnauthenticated();
    useEffectSetStorageThemeFromApi();
};
